<template lang="pug">
  .font-serif.tracking--20
    //- body
    .app__body.z-10.relative.bg-white.trans-cart(:class="{'translx_-25 sm-translx_-50 md-translx_-33 lg-translx_-25': cart}")
      .app__body__scrim.absolute.z-50.inset-0.cursor-pointer(v-show="cart", @click="hideCart")
      //- masthead logo
      logo.z-40.md-z-40.fixed(:black="!logoWhite || hideLanding", @click="logoClick")
      //- landing
      landing.bg-black.cursor-pointer.select-none(v-scroll-to="'#app__main'", v-if="!hideLanding", @visible="logoWhite = true", @hidden="logoWhite = false")
      //- main
      #app__main
        //- header
        #app__header.z-30.w-full.top-0.left-0.lg-blend-diff.lg-hover-blend-none-off(:class="stickyHdrClss")
          app-header.absolute.top-0.left-0.w-full.lg-hover-h-164(@menu="mblMenu = !mblMenu", :hasLanding="!hideLanding")
        //- (header-bar)
        #app__header-bar.z-20.bg-cerulean2.hidden.w-full.top-0.left-0.pointer-events-none(:class="[stickyHdrClss, {'app__header-bar--active': cart}]")
          .absolute.top-0.left-0.w-full.bg-inherit.h-164
        //- view
        transition(name="pagefade")
          router-view(:key="$route.path")
        //- announcements
        announcements.z-40

    //- modals
    newsletter-popup

    //- cart
    cart.trans-cart(:style="{transform: !cart ? 'translateX(100%)' : 'none'}", @close="hideCart")
</template>

<script>
import '@/style/_main.css'
import _throttle from 'lodash/throttle'
import AppHeader from '@/components/AppHeader'
import Cart from '@/views/Cart'
import Logo from '@/components/Logo'
import Landing from '@/components/Landing'
import Announcements from '@/components/Announcements'
import NewsletterPopup from '@/components/modals/NewsletterPopup'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'App',
  components: { AppHeader, Cart, Logo, Landing, Announcements, NewsletterPopup },
  data () {
    return {
      mblMenu: false,
      isSquished: false,
      logoWhite: false
    }
  },
  metaInfo: {
    titleTemplate (chunk) {
      return chunk ? `${chunk} – OTTOLINGER` : 'OTTOLINGER'
    }
  },
  computed: {
    ...mapState(['bus', 'cart', 'winW', 'winH']),
    hideLanding () {
      return this.$route.name !== 'home'
    },
    pinHdr () {
      return this.$route.name === 'home' && !this.hideLanding
    },
    stickyHdrClss () {
      return [
        // 'sticky'
        this.pinHdr ? 'sticky' : 'fixed md-sticky'
      ]
    }
  },
  methods: {
    ...mapMutations(['hideCart']),
    onResize: _throttle(function () {
      clearTimeout(this.afterResize)
      this.afterResize = setTimeout(() => {
        const update = (value, old, emit, commit) => {
          if (value === old) return
          this.$store.commit(commit, value)
          this.bus.$emit(emit, value)
        }
        update(window.innerWidth, this.winW, 'newWindowWidth', 'SET_WIN_W')
        update(window.innerHeight, this.winH, 'newWindowHeight', 'SET_WIN_H')
      }, 100)
    }, 50),
    logoClick () {
      if (this.$route.name === 'home') {
        this.hideLanding = false
        if (this.y < this.winH) return this.$scrollTo('#app__main')
        window.scroll(0, 0)
      }
      return this.$router.push('/')
    }
  },
  created () {
    this.$store.dispatch('getGlobals')
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
    this.$store.dispatch('createCheckout', true)
  }
}
</script>

<style>
@import './style/_variables.css';
/* header bar on header:hover */
@media (hover:hover) and (--bkpt-md) {
  #app__header-bar{
    display: block;
    transition: opacity 100ms, visibility 0s 100ms;
    mix-blend-mode: exclusion;
    opacity: 0;
    visibility: hidden;
  }
  #app__header:hover + #app__header-bar,
  #app__header-bar.app__header-bar--active{
    transition: opacity 100ms 20ms, visibility 0s 20ms;
    visibility:visible;
    opacity:1;
  }
}
</style>
